module.exports = __webpack_public_path__ + "static/aboutus-1-min-f68a21668f385e21dd4f8e439f7cfe88.png";